import { css } from '@emotion/react';

import { breakpoints } from '@/styles';
import { p2r } from '@/styles/fonts';

const styles = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1440px;
  padding: ${p2r(10)} 32px;
  margin: 0 auto;

  @media (max-width: ${breakpoints.tablet}px) {
    padding: ${p2r(10)} 16px;
  }
`;

export default styles;
